export const GET_DIMENSIONS_WATCHER =
  "app/WidgetResultByDimensionEngagement/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/WidgetResultByDimensionEngagement/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/WidgetResultByDimensionEngagement/GET_DIMENSIONS_FAILED"
